import React from 'react';

const Topbar = () => {
  return (
    <div className="container-fluid bg-dark py-2 d-none d-md-flex">
      <div className="container">
        <div className="d-flex justify-content-between topbar">
          <div className="top-info">
            <small className="me-3 text-white-50">
              <a href="#">
                <i className="fas fa-map-marker-alt me-2 text-secondary"></i>
              </a>
              Mohali, Punjab, India
            </small>
            <small className="me-3 text-white-50">
              <a href="mailto:info@aesos.in">
                <i className="fas fa-envelope me-2 text-secondary"></i>
              </a>
              info@aesos.in
            </small>
          </div>

          <div id="note" className="text-secondary d-none d-xl-flex">
            <small>Note : Connect with AESOS , We help you to Grow your Business </small>
          </div>

          <div className="top-link">
            <a href="https://www.facebook.com/share/18zqF6LFrB/" className="btn-light nav-fill btn btn-square rounded-circle me-2">
                <i className="fab fa-facebook-f text-primary"></i>
              </a>
              {/* <a href="https://x.com/theaesos?t=5yWEntt8ganZ2O559AjBEw&s=09" className="btn-light nav-fill btn btn-square rounded-circle me-2">
                <i className="fab fa-twitter text-primary"></i>
              </a> */}
              <a href="https://www.instagram.com/aesos.in?igsh=cnhybHBrZDRibXVk" className="btn-light nav-fill btn btn-square rounded-circle me-2">
                <i className="fab fa-instagram text-primary"></i>
              </a>
              <a href="https://www.linkedin.com/company/aesos/?viewAsMember=true" className="btn-light nav-fill btn btn-square rounded-circle me-0">
                <i className="fab fa-linkedin-in text-primary"></i>
              </a>
          </div>




          




        </div>
      </div>
    </div>
  );
};

export default Topbar;
